import { businessTypes_4kyx, taxPeriodList, payTypeList, businessScopeArr, serviceContryList, advCountryList, couponModules, PACKAGETYPE } from './product'
import { EPR_COUNTRY_LIST, VAT_COUNTRY_LIST } from './material'
import { VAT_SERVICE_TYPE, COMMON_SERVICE_TYPE } from '../enum/commonServiceType'
import { COMMON_COUNTRY } from '../enum/commonCountry'
import { OFFICIAL_IS_INCLUDE, productTypeEnum, VIP_TYPE, ACTIVITY_MENU, ACTIVITY_URL, scoreStoreProductType, ACTIVITY_TYPE } from '../enum/env'
import { getCouponMoneyShowText, getDeductionLimit, getCouponMoneyOrTenths, getCouponSuffixText, getCouponPriceIcon } from '../common/coupon'
import { getLabelText } from '../utils'
import GenerateEnum from '../generateEnum'

let standardList = []
let standardMap = {}
VAT_SERVICE_TYPE.enumArray.forEach((item) => {
  standardList.push({ ...item })
  standardMap[item.serverType] = item.serverDetailName
})
const convertToHalfWidth = function (str) {
  let convertedStr = ''
  for (let i = 0; i < str.length; i++) {
    const charCode = str.charCodeAt(i)
    if (charCode >= 65281 && charCode <= 65374) {
      // 将全角符号转换为半角符号
      convertedStr += String.fromCharCode(charCode - 65248)
    } else {
      // 其他字符保持不变
      convertedStr += str[i]
    }
  }
  return convertedStr.replace(/\。/g, '.')
}
const thousandNum = function (s, n) {
  if (isNaN(s)) return s
  let isNegative = false
  if (s < 0) {
    let num = s.toString()
    s = num.slice(1)
    isNegative = true
  }
  s = Number(s).toFixed(2)
  n = n > 0 && n <= 20 ? n : 2
  let r = s.split('.')[1]
  s = parseFloat((s + '').replace(/[^\d\.-]/g, '')) + ''
  let l = s.split('.')[0].split('').reverse()
  let t = ''
  for (let i = 0; i < l.length; i++) {
    t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? ',' : '')
  }
  if (isNegative) {
    t = t + '-'
  }
  return !r ? t.split('').reverse().join('') : t.split('').reverse().join('') + '.' + r
}

// js字符串自动识别中文符号转化成英文符号
const convertChinesePunctuations = function (str) {
  const punctuationsMap = {
    '，': ',', // 中文逗号 -> 英文逗号
    '。': '.', // 中文句号 -> 英文句号
    '！': '!', // 中文感叹号 -> 英文感叹号
    '？': '?', // 中文问号 -> 英文问号
    '；': ';', // 中文分号 -> 英文分号
    '：': ':', // 中文冒号 -> 英文冒号
    '“': '"', // 中文左双引号 -> 英文双引号
    '”': '"', // 中文右双引号 -> 英文双引号
    '‘': "'", // 中文左单引号 -> 英文单引号
    '’': "'", // 中文右单引号 -> 英文单引号
    '（': '(', // 中文左括号 -> 英文左括号
    '）': ')', // 中文右括号 -> 英文右括号
    '【': '[', // 中文左方括号 -> 英文左方括号
    '】': ']', // 中文右方括号 -> 英文右方括号
    '《': '<', // 中文左书名号 -> 英文小于号（或根据需求调整）
    '》': '>', // 中文右书名号 -> 英文大于号（或根据需求调整）
    '—': '-', // 中文破折号 -> 英文连字符
    '…': '...' // 中文省略号 -> 英文省略号
  }

  // 使用正则表达式匹配所有需要替换的中文标点
  return str.replace(/[，。！？；： “”‘’（）【】《》—…]/g, (match) => punctuationsMap[match] || match)
}

// js字符串自动识别链接成超链接
const autolink = function (text) {
  // 正则表达式匹配URL
  const urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi

  // 使用replace方法替换URL为超链接
  if (!text) {
    return ''
  }
  return text.replace(urlRegex, function (url) {
    return '<a href="' + url + '" target="_blank">' + url + '</a>'
  })
}

const readFileAsArrayBuffer = function (file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.onerror = reject
    reader.readAsArrayBuffer(file)
  })
}

const filterServiceProgress = function (val) {
  const progressMap = {
    0: getLabelText({ key: 'remote.common.notStarted', text: '未开始' }),
    1: getLabelText({
      key: 'remote.common.serviceDataToBeSubmitted',
      text: '待提交服务资料'
    }),
    2: getLabelText({ key: 'remote.common.processing', text: '处理中' }),
    3: getLabelText({ key: 'remote.common.completed', text: '已完成' }),
    5: getLabelText({ key: 'remote.common.refunded', text: '已退款' }),
    6: getLabelText({ key: 'remote.common.refundInProgress', text: '退款中' }),
    7: getLabelText({ key: 'remote.common.cancelled', text: '已取消' }),
    8: getLabelText({ key: 'remote.common.frozen', text: '已冻结' })
  }
  return progressMap[val]
}

const isJson = function (str) {
  try {
    JSON.parse(str)
    return true
  } catch (e) {
    return false
  }
}

const getShowColumns = function (uniqueKey, columns) {
  const str = localStorage.getItem(uniqueKey) || ''
  try {
    const obj = JSON.parse(str)
    const arr = columns
      .map((item) => {
        const object = obj.columns.find((it) => it.value == item.dataIndex)
        let data = { ...item, checked: object ? object.checked : true }
        if (object) {
          data.sortIndex = object.sortIndex
        }
        return data
      })
      .filter((item) => item.checked)
    // 有排序
    const array1 = arr.filter((item) => item.sortIndex || item.sortIndex === 0).sort((a, b) => a.sortIndex - b.sortIndex)
    // 无排序（新增字段）
    const array2 = arr.filter((item) => !item.sortIndex && item.sortIndex !== 0 && !item.unsupported)
    // 不可选（action）
    const array3 = arr.filter((item) => item.unsupported)
    return [...array1, ...array2, ...array3]
  } catch (e) {
    return columns
  }
}

const getIsShowQueryKey = function ({ uniqueKey, key, queryParam, queryKeys }) {
  const str = localStorage.getItem(uniqueKey) || ''
  try {
    const obj = JSON.parse(str)
    const arr = queryKeys
      .map((item) => {
        const object = obj.queryKeys.find((it) => it.value == item.value)
        return {
          ...item,
          checked: object ? object.checked : true
        }
      })
      .filter((item) => item.checked)
      .map((item) => item.value)
    return queryParam[key] || arr.includes(key)
  } catch (e) {
    return true
  }
}

const getNewShowColumns = function (obj) {
  const { data, columns } = obj
  try {
    const array = JSON.parse(data || '')
    const arr = columns
      .filter((item) => !item.unsupported)
      .map((item) => {
        const object = array.find((it) => it.value == item.dataIndex)
        item.isShow = object ? object.isShow : false
        item.sort = object ? object.sort : Infinity
        return item
      })
    // 展示字段项
    const array1 = arr.filter((item) => item.isShow).sort((a, b) => a.sort - b.sort)
    // 不可选（action）
    const array2 = columns.filter((item) => item.unsupported)
    return [...array1, ...array2]
  } catch (e) {
    // 默认展示
    let array1 = columns.filter((item) => item.defaultShow)
    // 不可选（action）
    const array2 = columns.filter((item) => item.unsupported)
    if (array1.length) {
      return [...array1, ...array2]
    }
    return columns
  }
}

const getNewShowQueryKeys = function (obj) {
  const { data, queryKeys, queryParam } = obj
  try {
    const array = JSON.parse(data || '')
    const arr = queryKeys.map((item) => {
      const object = array.find((it) => it.value == item.value)
      item.isShow = object ? object.isShow : !!item.defaultShow
      item.sort = object ? object.sort : 999
      return item
    })
    // 展示筛选项
    let array1 = arr
      .map((item) => {
        let currentIsShow =
          !!((queryParam[item.value] && !Array.isArray(queryParam[item.value])) || (Array.isArray(queryParam[item.value]) && queryParam[item.value].length) || queryParam[item.value] === 0) ||
          item.isShow
        // 有默认值需根据默认值判断
        if (item.defaultValue !== undefined) {
          currentIsShow = item.defaultValue != queryParam[item.value] || item.isShow
        }
        return { ...item, currentIsShow }
      })
      .sort((a, b) => a.sort - b.sort)
    return array1
  } catch (e) {
    const arr = queryKeys.map((item, index) => {
      let currentIsShow = !!(queryParam[item.value] || queryParam[item.value] === 0) || !!item.defaultShow
      // 有默认值需根据默认值判断
      if (item.defaultValue !== undefined) {
        currentIsShow = item.defaultValue != queryParam[item.value] || !!item.defaultShow
      }
      return { ...item, sort: index + 1, currentIsShow }
    })
    const array = queryKeys.filter((item) => item.defaultShow)
    if (array.length) {
      return arr
    }
    return queryKeys.map((item, index) => ({
      ...item,
      sort: index + 1,
      currentIsShow: true
    }))
  }
}

// 获取最新的筛选项
const getNewLatestQueryParam = function (obj) {
  const { data, queryParam, queryKeys } = obj
  let params = { ...queryParam }
  try {
    const arr = JSON.parse(data || '')
    Object.keys(params).forEach((item) => {
      if (arr.find((it) => it.value?.split(',')?.includes(item))) {
        const flag = arr.filter((it) => it.isShow).some((it) => it.value?.split(',')?.includes(item))
        // 删除的筛选项如果有默认值，赋值默认值，没有删除筛选项
        if (!flag) {
          const obj = queryKeys.find((it) => it.value?.split(',')?.includes(item))
          if (obj?.defaultValue !== undefined) {
            params[item] = obj.defaultValue
          } else {
            delete params[item]
          }
        }
      }
    })
    return params
  } catch (e) {
    return params
  }
}

const filterBelongingToType = function (val) {
  return standardList.find((item) => item.value == val)?.belongingToType || ''
}

const getBusinessType_4kyx = function (country, serviceType) {
  let serviceTypeName = standardMap[serviceType]
  let res = undefined
  businessTypes_4kyx.forEach((item) => {
    if (item.show(country + '') && serviceTypeName.indexOf(item.value) > -1) {
      res = item.value
    }
  })
  return res
}

const ostProductProgressType = function (progress, serviceType) {
  let service = String(serviceType)
  let ordinaryArray = [
    '',
    getLabelText({
      key: 'remote.common.serviceDataToBeSubmitted',
      text: '待提交服务资料'
    }),
    getLabelText({ key: 'remote.common.processing', text: '处理中' }),
    getLabelText({ key: 'remote.common.completed', text: '已完成' }),
    getLabelText({ key: 'remote.common.processingFailed', text: '处理失败' }),
    getLabelText({ key: 'remote.common.refunded', text: '已退款' }),
    getLabelText({ key: 'remote.common.refundInProgress', text: '退款中' }),
    getLabelText({ key: 'remote.common.cancelled', text: '已取消' }),
    getLabelText({ key: 'remote.common.frozen', text: '已冻结' })
  ]
  if (service === COMMON_SERVICE_TYPE.CDS_REGISTRATION) {
    return ordinaryArray[progress || 0]
  }
  if ([COMMON_SERVICE_TYPE.VAT_TAX_NUMBER_APPLICATION, COMMON_SERVICE_TYPE.TAX_NUMBER_RENEW].includes(service)) {
    ordinaryArray[2] = getLabelText({
      key: 'remote.common.applicationInProgress',
      text: '申请中'
    })
    ordinaryArray[4] = getLabelText({
      key: 'remote.common.theApplicationFailed',
      text: '申请失败'
    })
  } else if (service === COMMON_SERVICE_TYPE.VAT_TRANSFORM_DECLARATION) {
    ordinaryArray[2] = getLabelText({
      key: 'remote.common.authorizationInProgress',
      text: '授权中'
    })
    ordinaryArray[4] = getLabelText({
      key: 'remote.common.authorizationFailed',
      text: '授权失败'
    })
  } else if (service === COMMON_SERVICE_TYPE.VAT_TAX_NUMBER_DEREGISTER) {
    ordinaryArray[4] = getLabelText({
      key: 'remote.common.logoutFailed',
      text: '注销失败'
    })
  }
  return ordinaryArray[progress]
}

const filterRenewalServerType = function (serverType) {
  if (serverType !== undefined && serverType !== null) {
    let text = standardList.find((item) => item.value == serverType || item.label == serverType)
    return text ? text.belongingToType : ''
  } else {
    return ''
  }
}

const filterServiceTypes = function (conditionValue) {
  if (conditionValue === undefined || conditionValue === null) {
    return []
  }
  return VAT_SERVICE_TYPE.enumArray.filter((item) => {
    if (Array.isArray(conditionValue)) {
      return conditionValue.includes(item.belongingToType)
    } else {
      return item.belongingToType === conditionValue
    }
  })
}

const findServiceType = function (belongingToType) {
  return VAT_SERVICE_TYPE.enumArray.map((item) => {
    if (item.belongingToType == belongingToType) {
      return item.serviceType
    }
  })
}

const fifterTaxPeriod = function (val) {
  if (val !== undefined && val !== null) {
    let text = taxPeriodList.find((item) => val == item.value)
    return text ? text.label : ''
  } else {
    return ''
  }
}

const removeDuplicateObj = function (arr, feild) {
  let obj = {}
  arr = arr.reduce((newArr, next) => {
    obj[next[feild]] ? '' : (obj[next[feild]] = true && newArr.push(next))
    return newArr
  }, [])
  return arr
}

const JumpuserCenter = function (obj, isReplace = true) {
  const href = `${process.env.VUE_APP_USER_CENTER_URL}/loading?back=${encodeURIComponent(!obj.url ? process.env.VUE_APP_ADMIN_URL : obj.url)}&type=${obj.type}`
  if (isReplace) {
    location.replace(href)
  } else {
    location.href = href
  }
}

const formatBytesToSize = function (byte) {
  let size = `${(byte / (1024 * 1024)).toFixed(2)}`
  const sizeStr = `${size}` // 转成字符串
  const index = sizeStr.indexOf('.') // 获取小数点处的索引
  const dou = sizeStr.substring(index + 1, 2) // 获取小数点后两位的值
  if (dou == '00') {
    // 判断后两位是否为00，如果是则删除00
    return sizeStr.substring(0, index) + sizeStr.substring(index + 3, 2)
  }
  return size
}

const funcUrlDel = function (parameter, paramUrl = '') {
  let url = paramUrl || location.href
  let urlparts = url.split('?')
  if (urlparts.length >= 2) {
    let prefix = encodeURIComponent(parameter) + '='
    let pars = urlparts[1].split(/[&;]/g)

    for (let i = pars.length; i-- > 0; ) {
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(i, 1)
      }
    }
    return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '')
  }
  return url
}

const isTrueValue = function (val) {
  return val || val === 0
}

const getLabel = function (value, options, labelFiled = 'label', valueField = 'value', noDataShow = '--') {
  if (labelFiled === 1) labelFiled = 'label'
  if (valueField === 1) valueField = 'value'
  if (noDataShow === 1) noDataShow = '--'
  return isTrueValue(value) ? options?.find((item) => item[valueField] == value)?.[labelFiled] ?? noDataShow : noDataShow
}

const createdEnumMap = function (enumItem) {
  let result = {}
  Object.keys(enumItem).forEach((key) => {
    result[enumItem[key].value] = enumItem[key].label
  })
  return result
}

const filterCountry = function (val) {
  let countryObj = COMMON_COUNTRY.enumArray.find((item) => item.value == val)
  return window?.platform == '23' ? countryObj?.label2 || countryObj?.label || '' : countryObj?.label
}

const sumName = function (item) {
  return PACKAGETYPE[item]
}

const getManageDetailName = (param = {}) => {
  let { eprType, default2, country, vm, serviceType, isVat } = param
  /*
                                                                                  suffix === ''  => 业务号管理-EPR注册号列表 的路由
                                                                                  suffix === '2'  => 服务单管理-EPR服务单 的路由
                                                                                */
  let suffix = vm?.$route?.name === 'europeanTab' ? '2' : ''
  let isEpr = !!eprType
  console.log(vm?.$route?.name, isEpr, 'isEpr', suffix, eprType, country, 'country', EPR_COUNTRY_LIST)
  if (isEpr) {
    return EPR_COUNTRY_LIST[country] && EPR_COUNTRY_LIST[country][eprType] ? EPR_COUNTRY_LIST[country][eprType] + suffix : default2 || 'commonManageDetail' + suffix
  }
  if (isVat && !(country == 0 && serviceType == 123) && ![49, 50, 74, 75].includes(+serviceType)) {
    return VAT_COUNTRY_LIST[country] || default2
  }
  // ！！！默认返回之前旧的路径！！！
  return default2
}

// 商户端用
const userGetManageDetailName = (param = {}) => {
  let { default2, country, vm, serviceType, by = 'eprType', eprType } = param

  if (country == 105) {
    // 澳大利亚GST
    if ([43, 44, 45, 46].includes(+serviceType)) {
      return 'TaxDetailAustraliaGST'
    }
  }

  // 英国WEEE
  if (country == 0 && eprType == 1) {
    return 'WEEEManageDetailEnglish'
  }
  // 波兰 电池法 WEEE
  if (country == 5 && (eprType == 1 || eprType == 3)) {
    return 'commonMultipleCategoriesDetailS'
  }
  // 瑞典 电池法 WEEE
  if (country == 10 && (eprType == 1 || eprType == 3)) {
    return 'commonMultipleCategoriesDetailS'
  }
  // 爱尔兰 电池法 WEEE
  if (country == 17 && (eprType == 1 || eprType == 3)) {
    return 'commonMultipleCategoriesDetailS'
  }
  // 荷兰 电池法
  if (country == 7 && eprType == 3) {
    return 'batteryManageDetailNetherlands'
  }
  // 奥地利包装法
  if (country == 8) {
    let paths = {
      1: 'weeeManageDetailAustria',
      2: 'packingManageDetailAustria',
      3: 'batteryManageDetailAustria'
    }
    return paths[eprType]
  }
  // 意大利EPR
  if (country == 3) {
    let paths = {
      1: 'WEEEManageDetailItaly',
      2: 'packingManageDetailItaly',
      3: 'batteryManageDetailItaly'
    }
    return paths[eprType]
  }
  // 瑞典包装法
  if (country == 10 && eprType == 2) {
    return 'packingManageDetailSweden'
  }
  // 西班牙
  if (country == 4) {
    let paths = {
      1: 'WEEEManageDetailSpain',
      2: 'packingManageDetailSPain',
      3: 'batteryManageDetailSpain'
    }
    return paths[eprType]
  }
  // //丹麦
  //if (country == 14 && eprType == 2) {
  //let paths = {
  //  2: 'DKPackingManageDetail',
  //}
  //return paths[eprType]
  // }

  // 德国走这里
  if (country == 2) {
    // 不知道哪里的写法，通过serviceType判断
    if (by === 'serviceType') {
      if ([101, 106, 127].includes(+serviceType)) return 'WEEEManageDetailGermany'
      if ([102, 105, 107].includes(+serviceType)) return 'packingManageDetailGermany'
      if ([103, 108, 126].includes(+serviceType)) return 'batteryManageDetailGermany'
      if ([123].includes(+serviceType)) return 'commonMultipleCategoriesDetailS'
    }
    // 默认通过eprType判断
    if (by === 'eprType') {
      let paths = {
        1: 'WEEEManageDetailGermany',
        2: 'packingManageDetailGermany',
        3: 'batteryManageDetailGermany',
        7: 'commonMultipleCategoriesDetailS'
      }
      return paths[eprType]
    }
  }

  // 法国走这里
  if (country == 1) {
    // 不知道哪里的写法，通过serviceType判断
    if (by === 'serviceType') {
      if ([101, 127].includes(+serviceType)) return 'WEEEManageDetailFrance'
      if ([102, 105].includes(+serviceType)) return 'packingManageDetailFrance'
      if ([103, 126].includes(+serviceType)) return 'batteryManageDetailFrance'
      if ([115, 128].includes(+serviceType)) return 'spinManageDetailFrance'
      if ([116].includes(+serviceType)) return 'furnitureManageDetailFrance'
      if ([122].includes(+serviceType)) return 'toysManageDetailFrance'
      if ([129].includes(+serviceType)) return 'tyreManageDetailFrance'
      if ([130].includes(+serviceType)) return 'paperManageDetailFrance'
      if ([138].includes(+serviceType)) return 'sportsManageDetailFrance'
      if ([139].includes(+serviceType)) return 'diyGardenManageDetailFrance'
    }
    // 默认通过eprType判断
    if (by === 'eprType') {
      let paths = {
        1: 'WEEEManageDetailFrance',
        2: 'packingManageDetailFrance',
        3: 'batteryManageDetailFrance',
        4: 'spinManageDetailFrance',
        5: 'furnitureManageDetailFrance',
        6: 'toysManageDetailFrance',
        8: 'tyreManageDetailFrance',
        9: 'paperManageDetailFrance',
        10: 'sportsManageDetailFrance',
        11: 'diyGardenManageDetailFrance'
      }
      return paths[eprType]
    }
  }
  let s = eprType > 0 ? default2 || 'commonManageDetail' : default2
  // ！！！默认返回之前旧的路径！！！
  return s
}

const fn_5kd6 = (v, icon) => {
  if (!v) return '0.00'
  if (v == 0) return '0.00'
  return `${v < 0 ? '+' : '-'}${icon || '￥'}${Math.abs(v).toFixed(2)}`
}

const getPayType = function (val) {
  if (val !== undefined && val !== null) {
    const obj = payTypeList.find((i) => {
      return i.value == val
    })
    return (obj && obj.text) || ''
  } else {
    return ''
  }
}

const sumBusinessScope = function (data) {
  let list = []
  if (data && data.length > 0) {
    for (let i = 0; i < data.length; i++) {
      let obj = businessScopeArr.find((item) => {
        return item.value == data[i]
      })
      if (obj) {
        list.push(obj.label)
      } else {
        list.push(data[i])
      }
    }
  }
  return list.join(',')
}

const getQueryString = function (name) {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  let r = location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  let iframeToken = localStorage.getItem('iframeToken')
  if (iframeToken) {
    return iframeToken
  }
  return null
}

const isShowGf = function (data) {
  return (
    data.serviceType != COMMON_SERVICE_TYPE.VIP_SERVICE &&
    data.officialIsInclude == OFFICIAL_IS_INCLUDE.NO &&
    data.showOfficePrice !== undefined &&
    data.showOfficePrice !== null &&
    data.showOfficePrice !== ''
  )
}

const getBuyProductList = function ({ buyList = [], productInfoList, vipType }) {
  if (productInfoList?.length) {
    buyList.forEach((item) => {
      let objData = productInfoList.find((x) => x.cartId == item.id && !item.newUserZoneId)
      // 根据cartId数据对比，并且当前商品不是套餐（套餐不可以参加活动）
      if (objData && item.productType != productTypeEnum.SETMEAL) {
        let { multipleDiscount = 0, multiplePrice = 0, discountUnitPrice, fullReductionDiscount = 0, fullReductionPrice = 0 } = objData || {}
        if (vipType == VIP_TYPE.VIP) {
          item.multipleVipDiscount = multipleDiscount
          item.multipleVipPrice = multiplePrice
        } else if (vipType == VIP_TYPE.SVIP) {
          item.multipleSvipDiscount = multipleDiscount
          item.multipleSvipPrice = multiplePrice
        } else {
          item.multipleDiscount = multipleDiscount
          item.multiplePrice = multiplePrice
        }
        item.fullReductionDiscount = fullReductionDiscount
        item.fullReductionPrice = fullReductionPrice
        item.discountUnitPrice = discountUnitPrice
        // isFullRankPrice自定义字段，因为后端分配的时候会有价格除不尽，未生成订单和生成订单后的分配逻辑不一致（未生成订单前会有一个商品多个数量，商品又是合并状态），具体分配逻辑可问后端，
        // 当优惠券选择完后自定义的满减阶梯优惠字段重置，防止活动与优惠券冲突导致的不参加活动但是优惠字段还在
        item.isFullRankPrice = 0
      }
      if (item?.activity?.activityType == ACTIVITY_TYPE.PRICESFOLDS) {
        if (objData?.canUseActFlag && objData.seckillActivityProduct) {
          item.activity.multipleDiscount = objData.seckillActivityProduct.multipleDiscount || 0
          item.activity.multipleSillCount = objData.seckillActivityProduct.multipleSillCount || 0
        }
      } else if (item?.activity?.activityType == ACTIVITY_TYPE.FULL_DISCOUNT && objData?.canUseActFlag && objData.seckillActivityProduct) {
        item.activity.rankIndex = objData.seckillActivityProduct.rankIndex
        item.activity.activityRankArray = objData.seckillActivityProduct.activityRankArray || []
      }
    })
  }
  return buyList
}

const toAddActivityPage = function ({ item, type }) {
  let menu = ACTIVITY_MENU[item.activityType]
  let href = location.href.split('/')[0]
  if (type == 'isNoGroup') {
    href = `${href}/SalesActivityData/activity/${menu}/${ACTIVITY_URL[item.activityType]}?activityId=${item.activityId}&id=${item.activityMainId}&activityType=${item.activityType}`
  } else {
    href = `${href}/SalesActivityData/activity/spellGroupIndex/spellGroupDetail`
    href = `${href}?configId=${item.configId}`
  }
  window?.open(href)
}

const filterServiceType = function (val) {
  if (val !== undefined && val !== null) {
    return COMMON_SERVICE_TYPE.getValueToLabel(String(val)) || ''
  } else {
    return ''
  }
}

const separateGermany = function (item = {}, strH = '') {
  return +item.country === 2 && ['102', '105'].includes(item.serverType)
    ? strH + getLabelText({ key: 'remote.common.weight', text: '重量' })
    : getLabelText({ key: 'remote.common.quantity', text: '数量' })
}

const advFilterCountry = function (val, serviceType) {
  // console.log(serviceContryList, 'serviceContryList')
  let countryObj = serviceContryList.find((item) => item.value == val)
  return countryObj?.country
}

const nonStandardGoods = function (item) {
    /*
     *  非标品
     *  德国 wee追加、注销、续费；
     *  德国 包装法追加、注销、续费；
     *  德国 电池法追加、注销、续费；
     *  西班牙 WEEE追加
     *  西班牙 包装法追加
     *  瑞典 包装法追加
     *  意大利 海牙认证
     *  授权代表追加 和 平台验证 和产品组 和 授权代表追加（产品组） 四种服务类型都不能直接加购
     */
    return (
        (item.country == '2' &&
            [
                '106',
                '107',
                '108',
                '149',
                '201',
                '202',
                '203',
                '301',
                '302',
                '303',
                COMMON_SERVICE_TYPE.ADDITIONAL_WEIGHT_FOR_PACKAGING_METHOD,
                COMMON_SERVICE_TYPE.BATTERY_ADD_WEIGHT,
                COMMON_SERVICE_TYPE.PLASTIC_TAX_ADD_BRAND,
                COMMON_SERVICE_TYPE.PLASTIC_TAX_ADD_WEIGHT
            ].includes(item.serviceType)) ||
        (item.country == '4' && ['106', '107', COMMON_SERVICE_TYPE.BATTERY_ADD_WEIGHT, COMMON_SERVICE_TYPE.WEEE_ADD_WEIGHT].includes(item.serviceType)) ||
        (item.country == '10' && ['107'].includes(item.serviceType)) ||
        ['188', '189', '190', '191'].includes(item.serviceType) ||
        (item.country == '1' && item.serviceType == '130') ||
        (item.country == '999' && item.serviceType == '9000') ||
        (item.country == COMMON_COUNTRY.IT && item.serviceType == COMMON_SERVICE_TYPE.HAGUE_CERTIFICATION) ||
        (item.country == '3' &&
            [
                COMMON_SERVICE_TYPE.ADDITIONAL_WEIGHT_FOR_PACKAGING_METHOD,
                COMMON_SERVICE_TYPE.BATTERY_ADD_WEIGHT,
                COMMON_SERVICE_TYPE.WEEE_ADD_WEIGHT,
                COMMON_SERVICE_TYPE.BATTERY_ADD_BRAND,
                COMMON_SERVICE_TYPE.WEEE_ADD_BRAND
            ].includes(item.serviceType)) ||
        (['5', '10', '17'].includes(item.country) && [COMMON_SERVICE_TYPE.BATTERY_ADD_BRAND, COMMON_SERVICE_TYPE.WEEE_ADD_BRAND].includes(item.serviceType)) ||
        ([COMMON_COUNTRY.IE].includes(item.country) && [COMMON_SERVICE_TYPE.BATTERY_ADD_WEIGHT, COMMON_SERVICE_TYPE.WEEE_ADD_WEIGHT].includes(item.serviceType)) ||
        ([COMMON_COUNTRY.PL].includes(item.country) && [COMMON_SERVICE_TYPE.ADDITIONAL_WEIGHT_FOR_PACKAGING_METHOD, COMMON_SERVICE_TYPE.WEEE_ADD_WEIGHT].includes(item.serviceType)) ||
        ([COMMON_COUNTRY.BE].includes(item.country) && [COMMON_SERVICE_TYPE.BATTERY_ADD_WEIGHT, COMMON_SERVICE_TYPE.ADDITIONAL_WEIGHT_FOR_PACKAGING_METHOD, COMMON_SERVICE_TYPE.WEEE_ADD_WEIGHT].includes(item.serviceType)) ||
        ([COMMON_COUNTRY.IT].includes(item.country) && ['95'].includes(item.serviceType)) ||
        (
            [COMMON_COUNTRY.NL].includes(item.country) && [
                COMMON_SERVICE_TYPE.PACKING_ADD_BRAND,
                COMMON_SERVICE_TYPE.ADDITIONAL_WEIGHT_FOR_PACKAGING_METHOD,
                COMMON_SERVICE_TYPE.BATTERY_ADD_BRAND,
                COMMON_SERVICE_TYPE.BATTERY_ADD_WEIGHT,
                COMMON_SERVICE_TYPE.WEEE_ADD_WEIGHT,
                COMMON_SERVICE_TYPE.WEEE_ADD_BRAND,
                COMMON_SERVICE_TYPE.TEXTILE_ADD_WEIGHT,
            ].includes(item.serviceType)
        ) ||
        (item.country == COMMON_COUNTRY.JP && [COMMON_SERVICE_TYPE.AUTHORIZATION_PRODUCT_SERIES, COMMON_SERVICE_TYPE.AUTHORIZATION_PRODUCT_SERIES_ADD].includes(item.serviceType))
    )
}

/**
 * 判断标品，但需要弹窗展示(非德国)
 * WEEE注销、包装法注销、电池法注销、纺织法注销、家具法注销、玩具法注销、纸张法注销、轮胎法注销、体育和休闲运动注销、DIY和园艺注销
 *
 */
const eprStandardGoods = function (item) {
  const { country, serviceType } = item
  return ([301, 302, 303, 315, 316, 322, 323, 324, 325, 326].includes(+serviceType) && country != 2) || [328, 179].includes(+serviceType)
}

// 判断是否可以直接加购
const filterAddDataStatus = function (data, from) {
  let item = JSON.parse(JSON.stringify(data))
  let status = 0 // 初始状态： 0 ， 2：英国注册弹框， 1:直接加购
  let skuList = item.skuList
  if (item.country === '0' && skuList && skuList[0].serviceType == '0' && from == 'newBuyList') {
    // 如果是英国注册申报，则打开注册申报时效提醒弹出
    status = 2
  }
  if (item.country === '1' && skuList && skuList[0].serviceType == '1' && from == 'newBuyList') {
    status = 3
  }
  if (status == 0) {
    // 单规格直接加购
    if (skuList.length == 1 && !nonStandardGoods(skuList[0]) && (item.isPurchaseNotes == 0 || !item.isPurchaseNotes)) {
      status = 1
    }
    if (eprStandardGoods(skuList[0])) {
      status = 0
    }
  }
  return status
}

function judgebusinessType(record) {
  if (['VAT', 'OD', 'RFC', 'JCT', 'GST', 'CT'].includes(record.businessType)) {
    if (record.serviceDataId) {
      return true
    } else {
      return false
    }
  }
  return true
}

const isShowSubmitBtn = function (that, record, type) {
  if (record.country) {
    record.taxCountry = record.country
  }
  if (record.serviceType == 11001) {
    return false
  }
  if (type == 1) {
    // 我的服务页面的判断
    return (
      // 英国CDS，progress为1 需要展示提交资料
      // 英国CDS，progress为1 需要展示提交资料
      (record.progress == '1' && record.serviceType == 38 && record.taxCountry == 0) || (record.progress == 1 && record.serviceDataId)
    )
  } else if (type == 2) {
    return record.progress == 1 && record.serviceDataId
  }

  return (
    // 工作台页面的判断
    // that.type === 0 &&
    that.inType(0, record) && judgebusinessType(record)
  )
}

// 商户端-我的服务-查看进度按钮的显示和隐藏 and 工作台-进度查询 订单详情的页面
const isShowViewProgress = function (that, record, type) {
  if (type == 2) {
    return record && record.isQuery == '1'
  }
  return record.isQuery == '1' && [1, 2, 3, 4, 8].includes(+record.progress)
}

const filterProgressLaw = function (val) {
  if (val.progress == '5') {
    return 'Cancelled & Refunded'
  }
  if (val.progress == '6') {
    return 'Cancelled & Refunded'
  }
  const map = {
    244: getLabelText({
      key: 'remote.common.declarationToBeUploaded',
      text: '待上传声明书'
    }),
    245: 'Information under review',
    246: 'POA to be signed',
    247: 'POA to be signed',
    248: 'POA under review',
    250: 'Awaiting submission',
    271: 'Receipt uploaded',
    340: 'Under examination',
    341: 'OA sent',
    346: 'OA sent',
    342: 'OA sent',
    343: 'OA sent',
    344: 'OA sent',
    345: 'OA sent',
    347: 'OA Information awaiting review',
    348: 'ROA awaiting submission',
    350: 'Published',
    381: getLabelText({
      key: 'remote.common.noaPendingDocumentSubmission',
      text: 'NOA-待提交资料'
    }),
    383: getLabelText({
      key: 'remote.common.noaPendingDocumentSubmission',
      text: 'NOA-待提交资料'
    }),
    384: getLabelText({
      key: 'remote.common.noaPendingDocumentSubmission',
      text: 'NOA-待提交资料'
    }),
    385: getLabelText({
      key: 'remote.common.noaPendingDocumentSubmission',
      text: 'NOA-待提交资料'
    }),
    386: getLabelText({
      key: 'remote.common.noaDocumentsPendingReview',
      text: 'NOA-资料待审核'
    }),
    387: getLabelText({
      key: 'remote.common.Noa_PendingDispatch',
      text: 'NOA-待送件'
    }),
    388: getLabelText({
      key: 'remote.common.noaOfficialReview',
      text: 'NOA-官方审查'
    }),
    389: getLabelText({
      key: 'remote.common.noaOfficialApproval',
      text: 'NOA-官方审核通过'
    }),
    440: 'Published',
    441: 'Published',
    442: 'Published',
    443: 'Published',
    444: 'Published',
    445: 'Published',
    446: 'Published',
    447: 'Published',
    448: 'Published',
    650: getLabelText({
      key: 'remote.common.completed',
      text: '已完成'
    }),
    660: 'Registered',
    770: 'Abandoned',
    880: 'Closed'
  }
  if (val.handState == '220' && val.rejectedTime) {
    return 'Information rejected'
  }
  return map[val.handState] || ''
}

const communicate = function () {
  window?.open('https://work.weixin.qq.com/kfid/kfc0c354b0c9fae4020')
}

const getFileName = function (upLoadImgUrl) {
  if (!upLoadImgUrl) return ''
  upLoadImgUrl = upLoadImgUrl.split('?')[0]
  let url = decodeURIComponent(upLoadImgUrl)
  let filename = ''
  if (url.indexOf('/') > 0) {
    filename = url.substring(url.lastIndexOf('/') + 1, url.length)
  } else {
    filename = url
  }
  if (filename.split('?')) {
    filename = filename.split('?')[0]
  }
  return filename
}

function getFileType(upLoadImgUrl) {
  if (!upLoadImgUrl) return ''
  let filename = getFileName(upLoadImgUrl)
  return filename ? filename.split('.')[1].toLowerCase() : ''
}

const filterVoucherCategory = function (arr, obj) {
  // 套餐服务目前不可用优惠券
  // if (obj.meal) {
  //   return `套餐服务${obj.isPvalid == '1' ? '（限时）' : ''}`
  // }
  let arr5 = []
  let allCountryList = [...serviceContryList, ...advCountryList]
  const timePeriod2 = getLabelText({
    key: 'remote.common.timePeriod2',
    text: '时段'
  })
  for (let i = 0; i < arr.length; i++) {
    if (arr[i] !== null && arr[i] !== undefined) {
      let item = arr[i].split(',')
      let str = obj.years[i] ? (item[1] === '4' ? timePeriod2 : obj.years[i]) : ''
      let currentItem = allCountryList.find((x) => {
        return x.value == item[0]
      })
      if (currentItem) {
        arr5.push(
          allCountryList.find((x) => {
            return x.value == item[0]
          }).country +
            str +
            filterServiceType(item[1])
        )
      }
    }
  }
  let arr6 = []
  if (arr5.length > 0) {
    const timeLimit = `（${getLabelText({
      key: 'remote.common.timeLimit',
      text: '限时'
    })}）`
    arr5.forEach((item) => {
      arr6.push(`${item}${obj.isPvalid == '1' ? timeLimit : ''}`)
    })
  }
  return arr6.join('，')
}

const buildObjOption = function (obj) {
  let arr = []
  Object.keys(obj).forEach((item, index) => {
    arr.push({
      index,
      value: item,
      label: item,
      children: []
    })

    if (obj[item]) {
      arr[index].children = Object.keys(obj[item]).map((childItem) => {
        return {
          value: childItem,
          label: obj[item][childItem]
        }
      })
    }
  })
  return arr
}

const exchangeRemarkGoDetail = function ({ productType, fromType, businessType, systemType, voucherType, voucherStatus }) {
  let { coupon, entity, thirdCard, thirdResource } = scoreStoreProductType
  let name = ''
  let query = {}
  switch (productType) {
    case coupon:
      name = 'couponList'
      if (voucherType == 0) {
        query.pageKeys = '1'
      } else if (voucherType == 1) {
        query.pageKeys = '0'
      }
      if (fromType == 'exchangeHistory') {
        //具体优惠券的状态
        if (voucherType == 0) {
          if (voucherStatus > 2) {
            query.voucherStatus = 2
          } else {
            query.voucherStatus = voucherStatus
          }
        } else {
          if (voucherStatus > 2) {
            query.voucherStatus = 2
          } else {
            let voucherObj = {
              0: 5,
              1: 1,
              2: 2
            }
            query.voucherStatus = voucherObj[voucherStatus]
          }
        }
      }
      break
    case entity:
      name = 'myPointsDetail'
      query.key = 3
      break
    case thirdCard:
      name = 'myPointsDetail'
      query.key = 3
      break
    case thirdResource:
      name = 'myPointsDetail'
      query.key = 3
      break
    default:
      break
  }
  return { name, query }
}

const getCouponText = function (item = {}) {
  const gettersObj = typeof window !== 'undefined' ? window?.app?.$store?.getters || {} : {}
  const { awardWay, awardMoney, orderMoneySill, ordeMoneySill, fullReductionType, serviceCount, discountTenths, discountType } = item
  const { kill, couponBag, service, full } = couponModules
  if (awardWay == kill) {
    return `${getLabelText({
      key: 'remote.common.noThreshold',
      text: '无门槛'
    })}，${getCouponMoneyShowText(item)}${getDeductionLimit(item)}`
  } else if (awardWay == couponBag) {
    return `${getCouponPriceIcon(item.discountType)}${getCouponMoneyOrTenths(item)}${getCouponSuffixText(item.discountType)}`
  } else if (awardWay == service) {
    return `${serviceCount + getLabelText({ key: 'remote.common.aService', text: '个服务' })}`
  } else if (awardWay == full) {
    return `${
      getLabelText({ key: 'remote.common.full', text: '满' }) +
      (orderMoneySill || ordeMoneySill) +
      getLabelText({
        key: gettersObj.ISGJTUS ? 'remote.common.dollar' : gettersObj.ISGJTEU ? 'remote.common.euro' : 'remote.common.yuan',
        text: gettersObj.ISGJTUS ? '美元' : gettersObj.ISGJTEU ? '欧元' : '元'
      })
    }${getCouponMoneyShowText(item)}，${
      fullReductionType == 0
        ? getLabelText({
            key: 'remote.common.ordinaryFullDiscount',
            text: '普通满减'
          })
        : getLabelText({
            key: 'remote.common.cycleFullMinus',
            text: '循环满减'
          })
    }${getDeductionLimit(item)}`
  }
}

const serviceBillProgress = function (record, type) {
    const {handState} = record
    // 客服
    if (type == -1) {
        if (record.progress == 5) {
            if (record.isPresented == 1) {
                return getLabelText({
                    key: 'remote.common.refunded1',
                    text: '已退款(兑换积分)',
                })
            }
            return getLabelText({
                key: 'remote.common.refunded',
                text: '已退款',
            })
        }
        if (record.progress == 9) {
            return getLabelText({
                key: 'remote.common.expired3',
                text: '已失效',
            })
        }
        if (record.progress == 6) {
            return getLabelText({
                key: 'remote.common.refundInProgress',
                text: '退款中',
            })
        }
        if (handState == 210) {
            if (record.rejectedTime) {
                return getLabelText({
                    key: 'remote.common.theInformationWasRejected',
                    text: '资料被驳回',
                })
            }
            return getLabelText({
                key: 'remote.common.dataToBeReviewed',
                text: '资料待审核',
            })
        }
        if (handState == 243) {
            return getLabelText({
                key: 'remote.common.deliveryReviewInProgress',
                text: '交付审核中',
            })
        }
        if (handState == 344) {
            if (record.rejectedTime) {
                return getLabelText({
                    key: 'remote.admin.reviewDocumentRejected',
                    text: '审-资料被驳回',
                })
            }
            return getLabelText({
                key: 'remote.common.Review_DocumentsPendingReview',
                text: '审-资料待审核',
            })
        }
        if (handState == 384) {
            if (record.rejectedTime) {
                return getLabelText({
                    key: 'remote.admin.nOADataRejected',
                    text: 'NOA-资料被驳回',
                })
            }
            return getLabelText({
                key: 'remote.admin.nOADataPendingReview',
                text: 'NOA-资料待审核',
            })
        }
        if (handState == 231) {
            return getLabelText({
                key: 'remote.common.pendingSubmissionOfPowerOfAttorney',
                text: '待提交委托书',
            })
        }
        if (handState == 233 || handState == 247) {
            return getLabelText({
                key: 'remote.admin.powerOfAttorneyHasBeenSubmitted',
                text: '已提交委托书',
            })
        }
        if (handState == 345 || handState == 348) {
            return getLabelText({
                key: 'remote.admin.reviewDeliveryInProgress',
                text: '审-交付处理中',
            })
        }
        if (handState == 346) {
            return getLabelText({
                key: 'remote.common.Review_AnalysisPendingConfirmation',
                text: '审-分析待确认',
            })
        }
        if (handState == 440) {
            return getLabelText({
                key: 'remote.common.officialAnnouncement',
                text: '官方公告',
            })
        }
        if (handState == 444) {
            if (record.rejectedTime) {
                return getLabelText({
                    key: 'remote.admin.objectionDataRejected',
                    text: '异议-资料被驳回',
                })
            }
            return getLabelText({
                key: 'remote.admin.objectionReplyPendingReview',
                text: '异议答辩-待审核',
            })
        }
        if (handState == 248) {
            return getLabelText({
                key: 'remote.common.poaUnderLawyerReview',
                text: '委托书律师审核中',
            })
        }
        if (handState == '265') {
            return getLabelText({
                key: 'remote.admin.drawingDeliveryReview',
                text: '绘-交付审核中',
            })
        }
    }
    // 交付
    if (type == -2) {
        if (record.progress == 5) {
            if (record.isPresented == 1) {
                return getLabelText({
                    key: 'remote.common.refunded1',
                    text: '已退款(兑换积分)',
                })
            }
            return getLabelText({
                key: 'remote.common.refunded',
                text: '已退款',
            })
        }
        if (record.progress == 9) {
            return getLabelText({
                key: 'remote.common.expired3',
                text: '已失效',
            })
        }
        if (record.progress == 6) {
            return getLabelText({
                key: 'remote.common.refundInProgress',
                text: '退款中',
            })
        }
        if (handState == 220) {
            if (record.rejectedTime) {
                return getLabelText({
                    key: 'remote.common.theInformationWasRejected',
                    text: '资料被驳回',
                })
            }
            return getLabelText({
                key: 'remote.common.dataToBeReviewed',
                text: '资料待审核',
            })
        }
        if (handState == 344) {
            return getLabelText({
                key: 'remote.common.Review_InformationToBeSubmitted',
                text: '审-待提交资料',
            })
        }
        if (handState == 345) {
            if (record.rejectedTime) {
                return getLabelText({
                    key: 'remote.admin.reviewDocumentRejected',
                    text: '审-资料被驳回',
                })
            }
            return getLabelText({
                key: 'remote.common.Review_DocumentsPendingReview',
                text: '审-资料待审核',
            })
        }
        if (handState == 346) {
            return getLabelText({
                key: 'remote.admin.reviewAnalysisCustomerServiceConfirmation',
                text: '审-分析客服确认',
            })
        }
        if (handState == 385) {
            if (record.rejectedTime) {
                return getLabelText({
                    key: 'remote.admin.nOADataRejected',
                    text: 'NOA-资料被驳回',
                })
            }
            return getLabelText({
                key: 'remote.admin.nOADataPendingReview',
                text: 'NOA-资料待审核',
            })
        }
        if (handState == 441) {
            return getLabelText({
                key: 'remote.admin.objectedBusinessSpecialistConfirmation',
                text: '被异议商务确认',
            })
        }
        if (handState == 444 && record.objectionFlag == 0) {
            return getLabelText({
                key: 'remote.admin.disputedMerchantsAwaitPayment',
                text: '被异议商户待支付',
            })
        }
        if (handState == 443 || (handState == 444 && record.objectionFlag == 1)) {
            return getLabelText({
                key: 'remote.common.Obj_AwaitingMerchantToProvideAdditionalInformation',
                text: '异议答辩-待商户补充资料',
            })
        }
        if (handState == 445) {
            return getLabelText({
                key: 'remote.admin.objectionReplyPendingReview',
                text: '异议答辩-待审核',
            })
        }
        if (handState == 247) {
            if (record.rejectedTime) {
                return getLabelText({
                    key: 'remote.common.thePowerOfAttorneyAasDenied',
                    text: '委托书被驳回',
                })
            }
            return getLabelText({
                key: 'remote.common.powerOfAttorneyPendingReview',
                text: '委托书待审核',
            })
        }
        if (handState == 248) {
            return getLabelText({
                key: 'remote.common.poaUnderLawyerReview',
                text: '委托书律师审核中',
            })
        }
        if (handState == 341 && record.rejectedTime) {
            return getLabelText({
                key: 'remote.admin.reviewTheProposalWasRejected',
                text: '审-方案被驳回',
            })
        }
        if (handState == 440 && record.rejectedTime) {
            return getLabelText({
                key: 'remote.admin.objectionProposalRejected',
                text: '异议-方案被驳回',
            })
        }
        if (handState == '264') {
            return getLabelText({
                key: 'remote.common.pendingSignature',
                text: '待完成签字',
            })
        }
    }
    const map = {
        110: getLabelText({
            key: 'remote.common.informationToBeSubmitted',
            text: '待提交资料',
        }),
        210: getLabelText({
            key: 'remote.common.customerServiceReviewInProgress',
            text: '客服审核中',
        }),
        218: getLabelText({
            key: 'remote.common.modelToBeConfirmed',
            text: '模型待确认',
        }),
        219: getLabelText({
            key: 'remote.common.waitPlatformCompleteModel',
            text: '待平台完成建模',
        }),
        220: getLabelText({
            key: 'remote.common.deliveryReviewInProgress',
            text: '交付审核中',
        }),
        221: getLabelText({
            key: 'remote.common.pendingUploadOfTransferAgreementTemplate',
            text: '待上传转让协议模板',
        }),
        222: getLabelText({
            key: 'remote.common.waitSignTransferAgreement',
            text: '待签署转让协议',
        }),
        223: getLabelText({
            key: 'remote.common.pendingReviewOfTransferAgreement',
            text: '待审核转让协议',
        }),
        224: getLabelText({
            key: 'remote.common.waitMailOriginalAgreement',
            text: '待邮寄协议原件',
        }),
        225: getLabelText({
            key: 'remote.common.pendingPlatformToCompleteDrawing',
            text: '待平台完成绘图',
        }),
        226: getLabelText({
            key: 'remote.common.waitConfirmDraw',
            text: '绘图待确认',
        }),
        243: getLabelText({
            key: 'remote.common.declarationToBeUploaded',
            text: '待上传声明书',
        }),
        244: getLabelText({
            key: 'remote.common.declarationToBeUploadedByLawyer',
            text: '待律师上传声明书',
        }),
        245: getLabelText({
            key: 'remote.common.theLawyerIsReviewingIt',
            text: '律师审核中',
        }),
        246: getLabelText({
            key: 'remote.common.powerOfAttorneyToBeSigned',
            text: '委托书待签署',
        }),
        247: getLabelText({
            key: 'remote.common.pendingDeliveryForReviewOfPowerOfAttorney',
            text: '待交付审核委托书',
        }),
        248: getLabelText({
            key: 'remote.common.pendingLawyerIsReviewOfPowerOfAttorney',
            text: '待律师审核委托书',
        }),
        261: getLabelText({
            key: 'remote.common.waitConfirmDraw1',
            text: '待确认绘图',
        }),
        262: getLabelText({
            key: 'remote.common.waitPlatformUploadDocuments',
            text: '待平台上传签字文件',
        }),
        263: getLabelText({
            key: 'remote.common.pendingSignature',
            text: '待完成签字',
        }),
        264: getLabelText({
            key: 'remote.common.documentsToBeReviewedAndSigned',
            text: '待审核签字文件',
        }),
        265: getLabelText({
            key: 'remote.common.documentsToBeReviewedAndSigned',
            text: '待审核签字文件',
        }),
        231: getLabelText({
            key: 'remote.common.pendingUploadOfPowerOfAttorney',
            text: '待上传委托书',
        }),
        232: getLabelText({
            key: 'remote.common.powerOfAttorneyToBeSigned',
            text: '委托书待签署',
        }),
        233: getLabelText({
            key: 'remote.common.powerOfAttorneyPendingReview',
            text: '委托书待审核',
        }),
        241: getLabelText({
            key: 'remote.common.pendingPaymentOfOfficialFeesByMerchants',
            text: '待商户支付官费',
        }),
        250: getLabelText({
            key: 'remote.common.waitingForOfficialSubmission',
            text: '等待递交官方',
        }),
        271: getLabelText({
            key: 'remote.common.aReceiptHasBeenIssued',
            text: '已下回执',
        }),
        280: getLabelText({
            key: 'remote.common.licensingFeeToBePaid',
            text: '待支付授权费',
        }),
        281: getLabelText({
            key: 'remote.common.authorizationReceiptToBeReceived',
            text: '待下授权回执',
        }),
        282: getLabelText({
            key: 'remote.common.authorizationReceiptReceived',
            text: '已下授权回执',
        }),
        340: getLabelText({
            key: 'remote.common.officialReview',
            text: '官方审查',
        }),
        341: getLabelText({
            key: 'remote.common.reviewComments',
            text: '审查意见',
        }),
        346: getLabelText({
            key: 'remote.common.Review_AnalysisPendingConfirmation',
            text: '审-分析待确认',
        }),
        342: getLabelText({
            key: 'remote.common.Review_AwaitingMerchantPayment',
            text: '审-待商户支付',
        }),
        343: getLabelText({
            key: 'remote.common.Review_InformationToBeSubmitted',
            text: '审-待提交资料',
        }),
        344: getLabelText({
            key: 'remote.common.Review_DocumentsPendingReview',
            text: '审-资料待审核',
        }),
        345: getLabelText({
            key: 'remote.common.Review_DocumentsPendingReview',
            text: '审-资料待审核',
        }),
        347: getLabelText({
            key: 'remote.common.Review_UnderLawyerReview',
            text: '审-律师审核中',
        }),
        348: getLabelText({
            key: 'remote.common.review_reviewComments',
            text: '审-待送件',
        }),
        350: getLabelText({
            key: 'remote.common.officialAnnouncement',
            text: '官方公告',
        }),
        381: getLabelText({
            key: 'remote.common.Noa_PendingPaymentOfOfficialFeesByMerchants',
            text: 'NOA-待商户支付官费',
        }), // 未支付官费
        383: getLabelText({
            key: 'remote.common.Noa_AwaitingSubmissionOfEvidence',
            text: 'NOA-待提交使用证据',
        }), // 已支付官费
        384: getLabelText({
            key: 'remote.common.Noa_AwaitingSubmissionOfEvidence',
            text: 'NOA-待提交使用证据',
        }), // 客服审核中
        385: getLabelText({
            key: 'remote.common.Noa_UnderReview',
            text: 'NOA-交付审核中',
        }),
        386: getLabelText({
            key: 'remote.common.noaUnderLawyerReview',
            text: 'NOA-律师审核中',
        }),
        387: getLabelText({
            key: 'remote.common.Noa_PendingDispatch',
            text: 'NOA-待送件',
        }),
        388: getLabelText({
            key: 'remote.common.Noa_OfficialReview',
            text: 'NOA-官方审查',
        }),
        389: getLabelText({
            key: 'remote.common.Noa_OfficialApproval',
            text: 'NOA-官方审核通过',
        }),
        391: getLabelText({
            key: 'remote.common.Verify_PendingPaymentOfOfficialFeesByMerchants',
            text: '核-待商户支付官费',
        }), // 未支付官费
        392: getLabelText({
            key: 'remote.common.Verify_OfficialFeesHaveBeenPaid',
            text: '核-已支付官费',
        }), // 已支付官费
        393: getLabelText({
            key: 'remote.common.Verify_UploadedOfficialFeeReceiptApproved',
            text: '核-已上传核准官费回执',
        }),
        440: getLabelText({
            key: 'remote.common.objectionPendingAnalysis',
            text: '被异议待分析',
        }),
        441: getLabelText({
            key: 'remote.common.objectionPendingConfirmation',
            text: '被异议待确认',
        }),
        442: getLabelText({
            key: 'remote.common.objectionPendingAwaitingMerchantPayment',
            text: '被异议待商户支付',
        }),
        443: getLabelText({
            key: 'remote.common.Obj_AwaitingMerchantToProvideAdditionalInformation',
            text: '异议答辩-待商户补充资料',
        }),
        444: getLabelText({
            key: 'remote.common.Obj_CustomerServiceReview',
            text: '异议答辩-客服审核',
        }),
        445: getLabelText({
            key: 'remote.common.Obj_DeliveryReview',
            text: '异议答辩-交付审核',
        }),
        446: getLabelText({
            key: 'remote.common.Obj_PendingDelivery',
            text: '异议答辩-待送件',
        }),
        447: getLabelText({
            key: 'remote.common.Obj_OfficialReview',
            text: '异议答辩-官方审查',
        }),
        448: getLabelText({
            key: 'remote.common.Obj_PendingClosure',
            text: '异议答辩-待结案',
        }),
        650: getLabelText({
            key: 'remote.common.completed',
            text: '已完成',
        }),
        660: getLabelText({
            key: 'remote.common.theCertificateHasBeenIssued',
            text: '已下证',
        }),
        770: getLabelText({key: 'remote.common.expired3', text: '已失效'}),
        880: getLabelText({key: 'remote.common.caseClosed', text: '已结案'})
    }
    if (record.handState == '250') {
        if (record.rpaApplyResult == 1) {
            return getLabelText({
                key: 'remote.common.waitingForOfficialSubmission',
                text: '等待递交官方',
            })
        } else {
            return getLabelText({
                key: 'remote.common.toBeDelivered',
                text: '待送件',
            })
        }
    }
    return map[record.handState] || ''
}

const getArryData = function (initialArr) {
  // 先获取一下这个数组中有多少个"name"
  const nameArr = []
  for (const i in initialArr) {
    if (nameArr.indexOf(initialArr[i].activity && initialArr[i].activity.activityId) === -1) {
      if (initialArr[i].activity) {
        nameArr.push(initialArr[i].activity.activityId)
      }
    }
  }
  // 新建一个包含多个list的结果对象
  const tempObj = {}
  // 根据不同的"name"生成多个数组
  for (const k in nameArr) {
    for (const j in initialArr) {
      if (initialArr[j].activity && initialArr[j].activity.activityId == nameArr[k]) {
        // 每次外循环时新建一个对应"name"的数组, 内循环时当前数组不变
        tempObj[nameArr[k]] = tempObj[nameArr[k]] || []
        tempObj[nameArr[k]].push(initialArr[j])
      }
    }
  }
  const arry = []
  for (const i in tempObj) {
    arry.push(tempObj[i])
  }
  return arry
}

// 非标品数据判断
const getNonStandardGoods = function (obj) {
  return !(
    [106, 107, 108, 201, 202, 203, 301, 302, 303].some((i) => {
      return i == obj.serverType
    }) && obj.country == 2
  )
}

const getHrefUrl = function (url, toPage) {
  let href = 'https://user.evatmaster.com'
  if (toPage == 'H5') {
    href =
      url.indexOf('user.evatmaster.com') != -1
        ? 'https://m.evatmaster.com'
        : url.indexOf('uat-user.ost.com') != -1
        ? 'http://uat-m.evatmaster.com'
        : url.indexOf('mc1.ost.com') != -1
        ? 'http://m1.ost.com'
        : 'http://localhost:8080'
  } else {
    href =
      url.indexOf('user.evatmaster.com') != -1
        ? 'https://user.evatmaster.com'
        : url.indexOf('uat-user.ost.com') != -1
        ? 'http://uat-user.ost.com'
        : url.indexOf('mc1.ost.com') != -1
        ? 'http://mc1.ost.com'
        : 'http://localhost:9000'
  }
  return href
}

const EPR_SERVICE_BUSINESS_ENUM = {
  W3E: { value: 1, label: 'WEEE', type: 'weee', declareServeType: 1, appendType: COMMON_SERVICE_TYPE.WEEE_ADD_WEIGHT },
  PACKAGING: {
    value: 2,
    label: getLabelText({
      key: 'remote.common.packagingMethod',
      text: '包装法'
    }),
    type: 'packing',
    declareServeType: 2,
    appendType: COMMON_SERVICE_TYPE.ADDITIONAL_WEIGHT_FOR_PACKAGING_METHOD
  },
  BATTERY: {
    value: 3,
    label: getLabelText({ key: 'remote.common.batteryMethod', text: '电池法' }),
    type: 'battery',
    declareServeType: 3,
    appendType: COMMON_SERVICE_TYPE.BATTERY_ADD_WEIGHT
  },
  SPINNING: {
    value: 4,
    label: getLabelText({ key: 'remote.common.textileMethod', text: '纺织法' }),
    type: 'textile',
    declareServeType: 6,
    appendType: COMMON_SERVICE_TYPE.TEXTILE_ADD_WEIGHT
  },
  FURNITURE: {
    value: 5,
    label: getLabelText({
      key: 'remote.common.theFurnitureAct',
      text: '家具法'
    }),
    type: 'homeHair'
  },
  TOYS: {
    value: 6,
    label: getLabelText({ key: 'remote.common.toyLaw', text: '玩具法' }),
    type: 'toy'
  },
  PLASTIC: {
    value: 7,
    label: getLabelText({ key: 'remote.common.plasticTax', text: '塑料税' }),
    type: 'plasticTax',
    appendType: COMMON_SERVICE_TYPE.PLASTIC_TAX_ADD_WEIGHT
  },
  TYRE: {
    value: 8,
    label: getLabelText({ key: 'remote.common.tireMethod', text: '轮胎法' }),
    type: 'tyre'
  },
  PAPER: {
    value: 9,
    label: getLabelText({ key: 'remote.common.paperMethod', text: '纸张法' })
  },
  SPORTS: {
    value: 10,
    label: getLabelText({
      key: 'remote.common.sportsAndRecreationalSports',
      text: '体育和休闲运动'
    }),
    type: 'sport'
  },
  DIY_GARDEN: {
    value: 11,
    label: getLabelText({
      key: 'remote.common.diyAndGardeningTools',
      text: 'DIY和园艺工具'
    }),
    type: 'diyGarden'
  }
}
export const EPR_SERVICE_BUSINESS_ENUM_CREAT = new GenerateEnum(EPR_SERVICE_BUSINESS_ENUM)

/**
 * 检查是否是线下提交资料
 * @param {string} serviceType 服务类型
 * @param {string} country 国家
 * @returns {boolean} 是否线下提交资料
 */
export function checkIsOffLineSubmitInfo(serviceType, country) {
  let isOffLine = false
  return isOffLine
}

const EPR_SERVICE_BUSINESS_MAP = createdEnumMap(EPR_SERVICE_BUSINESS_ENUM)

// 跳转商品详情页面
function recommonedGoDetail(item, ACCESS_TOKEN) {
  const { productName, systemType, productId, recommendId } = item
  this.$statistics('Productrecommendationclick', {
    product_name: productName
  })
  let self = systemType == '04' ? ['04', '10'].includes(window?.platform) : systemType == window?.platform // 当前此商品是否为当前环境
  const token = this.$ls.get(ACCESS_TOKEN)
  let buyDetail = `buy/productDetail?productId=${productId}&recommendId=${recommendId}`
  let urlData = self ? buyDetail : `${buyDetail}&token=${token}`
  openOtherLink({ urlData, self, systemType })
}

function openOtherLink({ urlData, self, systemType }) {
  const SYSTEM_USER_URL = {
    '00': process.env.VUE_APP_OST_USER_URL,
    '01': process.env.VUE_APP_MDT_USER_URL,
    '04': process.env.VUE_APP_OVERSEA_COMPANY_DOMAIN
  }
  let baseUrl = self ? process.env.VUE_APP_USER_URL : SYSTEM_USER_URL[systemType]
  const url = `${baseUrl || ''}/${urlData}`
  window?.open(url)
}

const formatCurrency = function (amount = 0) {
  return amount.toLocaleString('en-US', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}

const toDetails = function (record, that) {
  record.skuId = record.skuId || record.productSku
  that.$router.push({ name: 'carbonLabelDetais', query: record })
}
//金额千分位
const money = function (s, n) {
  if (isNaN(s)) return s
  let isNegative = false
  if (s < 0) {
    let num = s.toString()
    s = num.slice(1)
    isNegative = true
  }
  s = Number(s).toFixed(2)
  n = n > 0 && n <= 20 ? n : 2
  let r = s.split('.')[1]
  s = parseFloat((s + '').replace(/[^\d\.-]/g, '')) + ''
  var l = s.split('.')[0].split('').reverse()
  t = ''
  for (let i = 0; i < l.length; i++) {
    t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? ',' : '')
  }
  if (isNegative) {
    t = t + '-'
  }
  return !r ? t.split('').reverse().join('') : t.split('').reverse().join('') + '.' + r
}

const replaceUrlProtocolAtStart = function (url) {
  const fullToHalfWidthMap = { ｈ: 'h', ｔ: 't', ｐ: 'p', ｓ: 's', '：': ':' }
  const convertToHalfWidth = (str) => {
    return str
      .split('')
      .map((char) => fullToHalfWidthMap[char] || char)
      .join('')
  }
  if (url) {
    // http:
    const str1 = convertToHalfWidth(url.toLowerCase().slice(0, 5))
    // https:
    const str2 = convertToHalfWidth(url.toLowerCase().slice(0, 6))
    if (str1 == 'http:') {
      const replaceUrl = url.replace(/^(.{5})/, str1)
      return { isReplace: true, replaceUrl }
    }
    if (str2 == 'https:') {
      const replaceUrl = url.replace(/^(.{6})/, str2)
      return { isReplace: true, replaceUrl }
    }
    return { isReplace: false, replaceUrl: url }
  }
  return { isReplace: false, replaceUrl: url }
}

const notEmpty = function (e) {
  if (Array.isArray(e)) {
    return e.length > 0
  } else if (Object.prototype.toString.call(e) === '[object Object]') {
    return Object.keys(e).length > 0
  } else {
    return !['', null, undefined, false].includes(e)
  }
}

const buildTree = function (rows, moduleId, parentId, children, rootId) {
  moduleId = moduleId || 'moduleId'
  parentId = parentId || 'parentId'
  children = children || 'children'
  rootId = rootId || 0
  const cloneData = JSON.parse(JSON.stringify(rows)) // 对源数据深度克隆
  return cloneData.filter((father) => {
    const branchArr = cloneData.filter((child) => father[moduleId] == child[parentId]) // 返回每一项的子级数组
    branchArr.length > 0 ? (father[children] = branchArr) : delete father[children] // 如果存在子级，则给父级添加一个children属性，并赋值
    return father[parentId] == rootId // 返回第一层
  })
}

function getConversionAfterName(val) {
  if (val) {
    const str = val.replace('$', '')
    let obj = {}
    try {
      obj = JSON.parse(str)
    } catch (err) {
      obj = {}
    }
    return obj.name || val || ''
  }
  return val || ''
}

/**
 * antd 通用的下拉框搜索过滤
 * @param input
 * @param option
 * @returns {boolean}
 */
function filterOption(input, option) {
  return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
}

//中文语言
function getDiscountFromCountry() {
  if (typeof window !== 'undefined' && window?.app?.$store?.getters?.['lang']) {
    const lang = window?.app?.$store?.getters?.['lang']
    return ['zh-CN'].includes(lang)
  } else {
    return true
  }
}

function getBookTitle(title) {
  return getDiscountFromCountry() ? `《${title}》` : title
}

function getMultipleConversionAfterName(val, split) {
  if (val) {
    const regex = /\{[^}]*\}/g
    return val
      .match(regex)
      .map((item) => getConversionAfterName(item))
      .join(split)
  }
  return ''
}

/**
 * 根据指定的小数位数来四舍五入
 * @param num
 * @param precision 默认2位小数
 * @returns {number}
 */
function roundAndTruncate(num, precision = 2) {
  if (typeof num !== 'number' || typeof precision !== 'number') {
    throw new Error('Both arguments must be numbers')
  }

  // 将数字乘以10的precision次方，以便操作小数点后的位数
  let factor = Math.pow(10, precision)
  // 乘以因子后四舍五入
  let rounded = Math.round(num * factor)
  // 再除以因子，得到四舍五入后的结果
  let result = rounded / factor

  // 将字符串转换回数字并返回
  return result
}

/**
 * 根据平台生成i18n的key
 * @param {Object} getters store的getters
 * @param {string} prefixKey i18n的key前缀
 * @returns {string} i18n的key
 */
function i18nKeyByPlatform(getters, prefixKey) {
  let key = prefixKey

  if (getters.ISOSTTYPE) {
    key = `${prefixKey}.ost`
  } else if (getters.ISLIUDUTYPE) {
    key = `${prefixKey}.ld`
  } else if (getters.ISLZTYPE) {
    key = `${prefixKey}.lz`
  } else if (getters.ISGJT) {
    key = `${prefixKey}.gjt`
  } else if (getters.ISXMTYPE) {
    key = `${prefixKey}.xm`
  }

  return key
}

function clearCookie(name, domain) {
  const date = new Date()
  date.setTime(date.getTime() - 1)
  document.cookie = name + '=; expires=' + date.toUTCString() + '; domain=' + domain + '; path=/'
}

/**
 * 把time时区的时间，换算成指定时区的时间
 * @param {momentjs} momentjs momentjs构造函数
 * @param {moment} time moment时间
 * @param {number} targetUTC 目标时区，默认UTC+1，1表示UTC+1，-1表示UTC-1
 * @returns {moment} 返回目标时区新的moment时间对象
 */
function getMomentByUTC(momentjs, time, targetUTC = 1) {
  const timestamp = time.valueOf()
  const curUTC = time.utcOffset() / 60
  const offsetUTC = curUTC - targetUTC

  //   返回目标时区的时间戳
  return momentjs(timestamp - offsetUTC * 60 * 60000) // 60000 是将分钟转换为毫秒
}

/**
 * 把moment时间修正成原来时区的时间
 * @param {momentjs} momentjs momentjs构造函数
 * @param {moment} time moment时间
 * @param {number} srcUTC 原来的时区，默认UTC+1，1表示UTC+1，-1表示UTC-1
 * @returns {moment} 返回目标时区新的moment时间对象
 */
function reviseMomentByUTC(momentjs, time, srcUTC = 1) {
  const timestamp = time.valueOf()
  const curUTC = time.utcOffset() / 60
  const offsetUTC = curUTC - srcUTC

  //   返回目标时区的时间戳
  return momentjs(timestamp + offsetUTC * 60 * 60000) // 60000 是将分钟转换为毫秒
}

function readFileHeader(file) {
  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.onload = (e) => {
      const arr = new Uint8Array(e.target.result.slice(0, 3))
      resolve(
        Array.from(arr)
          .map((b) => b.toString(16).padStart(2, '0'))
          .join('')
          .toUpperCase()
      )
    }
    reader.readAsArrayBuffer(file.slice(0, 3))
  })
}

// 图片加载函数（支持多种格式）
function loadImage(file) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    const url = URL.createObjectURL(file)
    img.onload = () => {
      URL.revokeObjectURL(url)
      resolve(img)
    }
    img.onerror = () => {
      URL.revokeObjectURL(url)
      reject(new Error('图片加载失败'))
    }
    img.src = url
  })
}

async function convertToJpg(originalFile) {
  // 步骤 1: 加载原始图片
  const img = await loadImage(originalFile)
  // 步骤 2: 创建 Canvas
  const canvas = document.createElement('canvas')
  canvas.width = img.width
  canvas.height = img.height
  // 步骤 3: 绘制到 Canvas
  const ctx = canvas.getContext('2d')
  // 处理透明背景（设置为白色）
  ctx.fillStyle = '#FFFFFF'
  ctx.fillRect(0, 0, canvas.width, canvas.height)
  ctx.drawImage(img, 0, 0)
  // 步骤 4: 转换为 JPEG Blob
  const jpgBlob = await new Promise((resolve) => {
    canvas.toBlob(
      (blob) => resolve(blob),
      'image/jpeg', // 指定 MIME 类型
      0.85 // 质量参数 (0-1)
    )
  })
  // 步骤 5: 转换为 File 对象
  const newName = originalFile.name.replace(/\.(jpe?g|png)$/i, '.jpg')
  return new File(
    [jpgBlob],
    newName, // 生成新文件名
    { type: 'image/jpeg' }
  )
}

async function isApng(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = (e) => {
      const buffer = e.target.result
      const uint8Array = new Uint8Array(buffer)

      // 检查PNG签名
      const pngSignature = [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a]
      if (!uint8Array.slice(0, 8).every((value, index) => value === pngSignature[index])) {
        resolve(false) // 不是PNG，直接返回false
        return
      }

      let offset = 8
      let hasApngChunk = false

      while (offset < uint8Array.length) {
        // 读取chunk长度
        const length = (uint8Array[offset++] << 24) | (uint8Array[offset++] << 16) | (uint8Array[offset++] << 8) | uint8Array[offset++]

        // 读取chunk类型
        const chunkType = String.fromCharCode(uint8Array[offset++], uint8Array[offset++], uint8Array[offset++], uint8Array[offset++])

        if (chunkType === 'acTL') {
          hasApngChunk = true
          break // 找到acTL，是APNG
        }

        // 跳过chunk数据和CRC
        offset += length + 4
      }

      resolve(hasApngChunk)
    }

    reader.onerror = (error) => {
      reject(error)
    }

    reader.readAsArrayBuffer(file)
  })
}

function toChineseCurrency(num) {
  // 验证输入是否为数字
  if (typeof num !== 'number' || isNaN(num)) {
    throw new Error('输入必须是数字')
  }

  // 处理负数
  const sign = num < 0 ? '负' : ''
  let absNum = Math.abs(num)

  // 处理整数和小数部分
  const integerPart = Math.floor(absNum)
  const decimalPart = Math.round((absNum - integerPart) * 100)

  // 定义数字和单位映射
  const digits = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
  const units = ['', '拾', '佰', '仟']
  const sections = ['', '万', '亿', '万亿']

  // 处理整数部分（0特殊处理）
  let chineseInteger = integerPart === 0 ? '零' : ''
  let groupStr
  let zeroCount = 0
  let allZero

  // 每4位一组处理
  const integerStr = integerPart.toString()
  const groupCount = Math.ceil(integerStr.length / 4)

  for (let i = 0; i < groupCount; i++) {
    const start = Math.max(0, integerStr.length - (i + 1) * 4)
    const end = integerStr.length - i * 4
    groupStr = integerStr.slice(start, end)

    // 处理当前组的4位数
    allZero = true
    let groupChinese = ''

    for (let j = 0; j < groupStr.length; j++) {
      const digit = parseInt(groupStr[j])
      const unit = units[groupStr.length - 1 - j]

      if (digit === 0) {
        zeroCount++
      } else {
        // 处理连续零（如1001）
        if (zeroCount > 0) {
          groupChinese += '零'
          zeroCount = 0
        }
        groupChinese += digits[digit] + unit
        allZero = false
      }
    }

    // 添加节权位（万/亿/万亿）并重置零计数
    if (!allZero) {
      groupChinese += sections[i]
      chineseInteger = groupChinese + chineseInteger
    }
    zeroCount = allZero ? 1 : 0
  }

  // 处理小数部分（角和分）
  let chineseDecimal = ''
  if (decimalPart > 0) {
    const jiao = Math.floor(decimalPart / 10)
    const fen = decimalPart % 10

    if (jiao > 0) chineseDecimal += digits[jiao] + '角'
    if (fen > 0) chineseDecimal += digits[fen] + '分'
  }

  // 组合最终结果
  const yuan = integerPart !== 0 || decimalPart === 0 ? '元' : ''
  const zheng = decimalPart === 0 ? '整' : ''

  return sign + chineseInteger + yuan + chineseDecimal + zheng
}

// 导出文件流
function exportFileBlob(content, fileName) {
  const blob = new Blob([content])
  if ('download' in document.createElement('a')) {
    // 非IE下载
    const elink = document.createElement('a')
    elink.download = fileName
    elink.style.display = 'none'
    elink.href = URL.createObjectURL(blob)
    document.body.appendChild(elink)
    elink.click()
    URL.revokeObjectURL(elink.href) // 释放URL 对象
    document.body.removeChild(elink)
  } else {
    // IE10+下载
    navigator.msSaveBlob(blob, fileName)
  }
}

export {
  getBookTitle,
  getDiscountFromCountry,
  convertToHalfWidth,
  thousandNum,
  readFileAsArrayBuffer,
  autolink,
  convertChinesePunctuations,
  filterServiceProgress,
  isJson,
  getShowColumns,
  getIsShowQueryKey,
  getNewShowColumns,
  getNewShowQueryKeys,
  getNewLatestQueryParam,
  getBusinessType_4kyx,
  filterServiceTypes,
  findServiceType,
  fifterTaxPeriod,
  removeDuplicateObj,
  JumpuserCenter,
  formatBytesToSize,
  funcUrlDel,
  isTrueValue,
  getLabel,
  createdEnumMap,
  filterCountry,
  sumName,
  getManageDetailName,
  userGetManageDetailName,
  fn_5kd6,
  getPayType,
  sumBusinessScope,
  getQueryString,
  isShowGf,
  getBuyProductList,
  filterRenewalServerType,
  toAddActivityPage,
  filterServiceType,
  filterBelongingToType,
  separateGermany,
  advFilterCountry,
  filterAddDataStatus,
  eprStandardGoods,
  isShowSubmitBtn,
  isShowViewProgress,
  filterProgressLaw,
  communicate,
  getFileName,
  getFileType,
  filterVoucherCategory,
  buildObjOption,
  exchangeRemarkGoDetail,
  getCouponText,
  serviceBillProgress,
  getArryData,
  getNonStandardGoods,
  getHrefUrl,
  EPR_SERVICE_BUSINESS_MAP,
  EPR_SERVICE_BUSINESS_ENUM,
  formatCurrency,
  ostProductProgressType,
  toDetails,
  money,
  recommonedGoDetail,
  openOtherLink,
  replaceUrlProtocolAtStart,
  notEmpty,
  buildTree,
  getConversionAfterName,
  filterOption,
  getMultipleConversionAfterName,
  roundAndTruncate,
  i18nKeyByPlatform,
  clearCookie,
  getMomentByUTC,
  reviseMomentByUTC,
  readFileHeader,
  convertToJpg,
  isApng,
  toChineseCurrency,
  exportFileBlob
}



// WEBPACK FOOTER //
// /data/.jenkins/workspace/ost-prod/@ost/lib/common/fn.js